import React from 'react';
import MatchGame from './game1/matchgame';

function App() {
  return (
    <div className="app-container">
      <MatchGame />
    </div>
  );
}

export default App;